import { SnapshotService } from './../../snapshot/snapshot.service';
import { ALMSLSBucketing } from './../../bucket/alm-sls-bucketing';
import { ALMNSFRBucketing } from './../../bucket/alm-nsfr-bucketing';
import { ALMRepricingBucketing } from './../../bucket/alm-repricing-bucketing';
import { BucketingStrategy } from './../../bucket/bucketing-strategy';
import { AppConfig } from '../../app.config';
import { ALMShortTermBucketing } from '../../bucket/alm-short-term-bucketing';
import { ALMLongTermBucketing } from '../../bucket/alm-long-term-bucketing';
import { ALMDashboardMetricData, walkAndBuildTreeNode, transposeDataToTenors, stampBreakDownDataWithTenorBuckets, } from '../alm-dashboard';
import { AwsUtil } from '../../authentication/aws.service';
import { DashboardEventService } from '../../dashboard/dashboard-event.service';
import { Subscription } from 'rxjs';
import { DashboardViewSelection } from '../../dashboard/dashboard-view-selection';
import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChildren, AfterViewInit, ViewChild } from '@angular/core';
import { TreeNode, SelectItem } from 'primeng/api';
import {
    ALMBreakDownConfig,
    convertFromCamelToHuman,
    ALMBreakDownData,
    GetALMBreakDownQueryDataResult,
    WebApiEndpoints,
    GetALMBreakDownQueryDataRequest,
    compareTenors,
    ALM_METRIC_CONFIG_DURATION_GAP,
    ALMLadderConfig,
    ALM_LADDER_CONFIGS,
    ALM_METRIC_CONFIG_WAL,
    ALM_METRIC_CONFIG_VOL_LIAB_VS_EAR,
    buildFXQuote,
    GetALMReportQueryResult,
    GetALMReportQueryRequest,
    ALMReportQueryData,
    ALM_METRIC_CONFIG_NSFR,
    ALM_METRIC_CONFIG_LCR,
    ALM_METRIC_CONFIG_ERROR_POSITIONS,
    ALMLadderStructureType,
    convertFromConstantToHuman,
} from '@liquitics/transaction';
// import { getStaticFXConversionRates } from '../../common/hard-coded';
import { TopNTableData, TopNTableConfig, TopNHistoricalData } from './top-n-table.component';
import { createALMHistoricalData, ALMHistoricalData } from '../common/alm-historical-chart-generator';
import * as am4charts from '@amcharts/amcharts4/charts';
import { ALMHistoricalChartComponent } from '../common/alm-historical-chart.component';
import { ALMBreakDownLadderTableComponent } from './alm-break-down-ladder-table.component';
import { moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';

interface ALMBreakDownRowData extends ALMBreakDownData {
    ln: number;
    ld: number;
}

@Component({
    selector: 'app-alm-trader',
    templateUrl: './alm-trader.component.html',
    styleUrls: ['./alm-trader.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ALMTraderComponent implements OnInit, OnDestroy, AfterViewInit {
    viewMode = 'LADDER';
    subscription: Subscription;
    selectedCurrency: string;
    selectedBatchIdentifier: string;
    ladderTreeNodes: TreeNode[];
    secondaryLadderTreeNodes: TreeNode[];
    ladderColumnNames: string[];
    ladderConfigs: SelectItem[];
    breakDownConfigs: SelectItem[];
    selectedLadderConfig: ALMLadderConfig;
    selectedBreakDownConfig: ALMBreakDownConfig;

    reportQueryTopNTableConfigs: TopNTableConfig[];
    reportQueryTreeNodes: TreeNode[];

    comparisonOperatingDates: SelectItem[];
    selectedComparisonOperatingDate: string;

    currentALMMetricDataResults: GetALMBreakDownQueryDataResult[] = [];

    almBucketing: BucketingStrategy;
    showDelta = false;
    showSecondaryLadder = false;
    isInError = false;

    completedOperatingDate: string;

    reportQueryConfigToType: { [key: string]: string } = {};
    notionalHistoricalData: ALMHistoricalData[];
    countHistoricalData: ALMHistoricalData[];

    globalFilterValue: string;

    @ViewChildren(ALMHistoricalChartComponent) historicalChartComponents: ALMHistoricalChartComponent[];
    @ViewChild('bdlt1', { static: false }) breakDownLadderTable1: ALMBreakDownLadderTableComponent;
    @ViewChild('bdlt2', { static: false }) breakDownLadderTable2: ALMBreakDownLadderTableComponent;

    breakDownLevels: SelectItem[];

    constructor(
        private dashboardEventService: DashboardEventService,
        private snapshotService: SnapshotService,
        private awsUtil: AwsUtil,
        private appConfig: AppConfig) {
    }

    ngOnInit() {
        this.completedOperatingDate = this.appConfig.getTodayStartUTC().subtract(1, 'day').format('YYYY-MM-DD');

        this.ladderConfigs = ALM_LADDER_CONFIGS
            .map((ladderConfig: ALMLadderConfig) => {
                return { label: ladderConfig.name, value: ladderConfig } as SelectItem;
            });
        this.comparisonOperatingDates = [1, 2, 3, 4, 5, 6, 7]
            .map((daysAgo: number) => {
                return {
                    label: `${daysAgo}D`,
                    value: this.appConfig.getTodayStartUTC().subtract(daysAgo, 'day').format('YYYY-MM-DD')
                } as SelectItem;
            });
        this.subscription = this.dashboardEventService.viewSelectionSubject.subscribe({
            next:
                (view: DashboardViewSelection<ALMDashboardMetricData>) => {
                    this.selectedCurrency = view.currency;
                    this.selectedBatchIdentifier = view.batchIdentifier;
                    this.refreshLaddersFromSource();
                    this.showReportQuery();
                }
        });
        this.subscription.add(this.dashboardEventService.viewModeSelectionSubject.subscribe({
            next:
                (viewMode: string) => {
                    this.viewMode = viewMode;
                }
        })
        );

        this.selectedLadderConfig = this.ladderConfigs[0].value;
        this.selectedComparisonOperatingDate = this.comparisonOperatingDates[0].value;
        this.updateBreakDownLevels();
        this.onLadderConfig();
    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    onLadderConfig() {
        if (this.selectedLadderConfig.bucketingStrategy === 'SHORT_TERM') {
            this.almBucketing = new ALMShortTermBucketing(this.appConfig.getTodayString());
        } else if (this.selectedLadderConfig.bucketingStrategy === 'LONG_TERM') {
            this.almBucketing = new ALMLongTermBucketing(this.appConfig.getTodayString());
        } else if (this.selectedLadderConfig.bucketingStrategy === 'REPRICING') {
            this.almBucketing = new ALMRepricingBucketing(this.appConfig.getTodayString());
        } else if (this.selectedLadderConfig.bucketingStrategy === 'NSFR') {
            this.almBucketing = new ALMNSFRBucketing(this.appConfig.getTodayString());
        } else if (this.selectedLadderConfig.bucketingStrategy === 'SLS') {
            this.almBucketing = new ALMSLSBucketing(this.appConfig.getTodayString());
        } else {
            throw new Error('Unsupported Bucketing Strategy: ' + this.selectedLadderConfig.bucketingStrategy);
        }

        this.breakDownConfigs = this.selectedLadderConfig.breakDownConfigs
            .map((bdc: ALMBreakDownConfig) => {
                return { label: convertFromCamelToHuman(bdc.name), value: bdc } as SelectItem;
            });
        this.selectedBreakDownConfig = this.selectedLadderConfig.breakDownConfigs[0];
        this.refreshLaddersFromSource();
    }

    updateBreakDownLevels() {
        this.breakDownLevels = ['bd1', 'bd2', 'bd3', 'bd4']
            .map((bd, index) => {
                return { label: `Level ${index + 1}`, value: bd } as SelectItem;
            });
    }

    refreshLaddersFromSource() {
        this.showSelectedLadderConfig();
        this.onShowSecondaryLadder(null);
    }

    rebuildLaddersFromExistingData() {
        const ladderRootNode = {} as TreeNode;
        this.buildTreeNodes(ladderRootNode, 0);
        this.rebuildLadder(ladderRootNode);
        const secondaryLadderRootNode = {} as TreeNode;
        this.buildTreeNodes(secondaryLadderRootNode, 1);
        this.rebuildSecondaryLadder(secondaryLadderRootNode);
    }

    onBreakDownConfig() {
        this.refreshLaddersFromSource();
    }

    onScenario() {
        this.refreshLaddersFromSource();
    }

    clearData() {
        this.ladderTreeNodes = null;
        this.secondaryLadderTreeNodes = null;
    }

    buildMetricDataRequest(almLadderConfig: ALMLadderConfig, operatingDate?: string): GetALMBreakDownQueryDataRequest {
        const request = {
            type: 'TRADER_LADDER',
            scenarioType: 'BASE',
            batchIdentifier: this.selectedBatchIdentifier,
            breakDown: this.selectedBreakDownConfig.name,
        } as GetALMBreakDownQueryDataRequest;
        if (operatingDate) {
            request.batchIdentifier = `${operatingDate}${request.batchIdentifier.substring(operatingDate.length)}`;
        }
        if (!this.selectedLadderConfig.useAllCurrencies) {
            request.currency = this.selectedCurrency;
        }
        request.breakDownQueryConfigName = almLadderConfig.name;
        return request;
    }

    // tempFudgeData(breakDownData: ALMBreakDownRowData[]) {
    //     const baseCurrency = this.appConfig.activeUserProfile.getCurrencies()[0];
    //     if (this.selectedLadderConfig.code === 'STL') {
    //         breakDownData
    //             .forEach((bdd: any) => {
    //                 bdd.ln = bdd.ln1 + bdd.ln2;
    //                 bdd.ld = bdd.ld1 + bdd.ld2;
    //             })
    //     } else if (this.selectedLadderConfig.code === 'LTL') {
    //         breakDownData
    //             .forEach((bdd: ALMBreakDownRowData) => {
    //                 bdd.ln = bdd.ln1 + bdd.ln2;
    //                 bdd.ld = bdd.ld1 + bdd.ld2;
    //             })
    //     } else if (this.selectedLadderConfig.code === 'LTV') {
    //         breakDownData
    //             .forEach((bdd: ALMBreakDownRowData) => {
    //                 bdd.ln = bdd.ln3 + bdd.ln4;
    //                 bdd.ld = bdd.ld3 + bdd.ld4;
    //             })
    //         // } else if (this.selectedLadderConfig.code === 'ST_CCY_POS') {
    //         //     breakDownData
    //         //         .forEach((bdd: ALMBreakDownRowData) => {
    //         //             bdd.ln = this.convertToBase(bdd.currency, baseCurrency, bdd.ln1 + bdd.ln2)
    //         //             bdd.ld = this.convertToBase(bdd.currency, baseCurrency, bdd.ld1 + bdd.ld2);
    //         //         })
    //         // } else if (this.selectedLadderConfig.code === 'LT_CCY_POS') {
    //         //     breakDownData
    //         //         .forEach((bdd: ALMBreakDownRowData) => {
    //         //             bdd.ln = this.convertToBase(bdd.currency, baseCurrency, bdd.ln1 + bdd.ln2)
    //         //             bdd.ld = this.convertToBase(bdd.currency, baseCurrency, bdd.ld1 + bdd.ld2);
    //         //         })
    //     } else if (this.selectedLadderConfig.code === 'SLS') {
    //         breakDownData
    //             .forEach((bdd: ALMBreakDownRowData) => {
    //                 bdd.ln = bdd.ln1;
    //                 bdd.ld = bdd.ld1;
    //             })
    //     } else {
    //         breakDownData
    //             .forEach((bdd: ALMBreakDownRowData) => {
    //                 bdd.ln = bdd.ln1;
    //                 bdd.ld = bdd.ld1;
    //             })
    //     }
    // }

    // convertToBase(fromCurrency: string, toCurrency: string, value: number): number {
    //     if (fromCurrency === toCurrency) {
    //         return value;
    //     }
    //     return value * (getStaticFXConversionRates().get(`${fromCurrency}.${toCurrency}`) || 0.0);
    // }

    isTransposedStructureType(ladderStructureType: ALMLadderStructureType): boolean {
        return ladderStructureType === 'TENOR_GROUPINGS'
    }

    isBucketAtEnd(ladderStructureType: ALMLadderStructureType): boolean {
        return ladderStructureType === 'DATA_BREAKDOWN_TENORS';
    }

    buildTreeNodes(rootLadderTreeNode: TreeNode, ladderIndex: number) {
        if (!this.currentALMMetricDataResults[ladderIndex]) {
            return;
        }
        let breakDownData: ALMBreakDownData[] = this.currentALMMetricDataResults[ladderIndex].breakDownData;

        breakDownData = stampBreakDownDataWithTenorBuckets(breakDownData, this.almBucketing);

        const bucketNames = this.almBucketing.getAllBucketTenors()
            .map((tenor: string) => {
                return this.almBucketing.getBucketNameFromTenor(tenor);
            });
        const numeratorFieldName = 'ln1';
        const denominatorFieldName = 'ld1';
        // this.tempFudgeData(breakDownData as ALMBreakDownRowData[]);
        const ladderingType = this.selectedLadderConfig.ladderingType;
        let aggregationLevels;
        let numeratorFieldNames;
        let denominatorFieldNames;
        let bucketLevel = -1;
        if (this.isTransposedStructureType(this.selectedLadderConfig.ladderStructureType)) {
            transposeDataToTenors(breakDownData, numeratorFieldName, denominatorFieldName, bucketNames, ladderingType);
            aggregationLevels = ['ccy', ...this.breakDownLevels.map((bdl) => bdl.value)];
            numeratorFieldNames = bucketNames
                .map((tenor: string) => {
                    return `${numeratorFieldName}${tenor}`;
                });
            denominatorFieldNames = bucketNames
                .map((tenor: string) => {
                    return `${denominatorFieldName}${tenor}`;
                });
            this.ladderColumnNames = bucketNames
        } else {
            if (this.isBucketAtEnd(this.selectedLadderConfig.ladderStructureType)) {
                aggregationLevels = ['ccy', ...this.breakDownLevels.map((bdl) => bdl.value), 'almTenorBucket',];
                bucketLevel = 5;
            } else {
                aggregationLevels = ['ccy', 'almTenorBucket', ...this.breakDownLevels.map((bdl) => bdl.value)];
                bucketLevel = 1;
            }
            numeratorFieldNames = ['ln1', 'ln2', 'ln3', 'ln4', 'ln5', 'ln6', 'ln7',];
            denominatorFieldNames = ['ld1', 'ld2', 'ld3', 'ld4', 'ld5', 'ld6', 'ld7',];
            this.ladderColumnNames = this.selectedLadderConfig.ladderValueNames;
        }
        const ladderRollupType = this.selectedLadderConfig.ladderRollupTypes[0];
        let ladderRollupTypes;
        if (this.selectedLadderConfig.ladderStructureType === 'TENOR_GROUPINGS') {
            ladderRollupTypes = this.ladderColumnNames
                .map(() => {
                    return ladderRollupType;
                });
        } else {
            ladderRollupTypes = this.selectedLadderConfig.ladderRollupTypes;
        }
        walkAndBuildTreeNode(
            ladderRollupTypes,
            rootLadderTreeNode,
            breakDownData,
            numeratorFieldNames,
            denominatorFieldNames,
            aggregationLevels,
            bucketLevel,
            this.selectedCurrency,
            this.almBucketing);
    }

    async buildTreeNodesFromRequest(request: GetALMBreakDownQueryDataRequest, rootLadderTreeNode: TreeNode, ladderIndex: number) {
        this.currentALMMetricDataResults[ladderIndex] = await this.awsUtil
            .webAPICall<GetALMBreakDownQueryDataResult>(WebApiEndpoints.QueryALMMetricData, request);
        this.buildTreeNodes(rootLadderTreeNode, ladderIndex);
    }

    rebuildLadder(ladderRootNode: TreeNode) {
        this.ladderTreeNodes = ladderRootNode.children
            .filter((childNode) => {
                return (childNode.label !== null);
            });
        if (this.ladderTreeNodes.length === 1 && !this.selectedLadderConfig.useAllCurrencies) {
            this.ladderTreeNodes[0].data.breakDown = this.selectedLadderConfig.name;
        }
        this.isInError = false;
    }

    showSelectedLadderConfig() {
        this.clearData();
        if (this.selectedBreakDownConfig && this.selectedCurrency) {
            const request = this.buildMetricDataRequest(this.selectedLadderConfig);
            const ladderRootNode = {} as TreeNode;
            this.buildTreeNodesFromRequest(request, ladderRootNode, 0)
                .then(() => {
                    this.rebuildLadder(ladderRootNode);
                })
                .catch((err) => {
                    console.log(err);
                    this.isInError = true;
                    this.clearData();
                });
        }
    }

    rebuildSecondaryLadder(ladderRootNode: TreeNode) {
        if (ladderRootNode.children) {
            this.secondaryLadderTreeNodes = ladderRootNode.children
                .filter((childNode) => {
                    return (childNode.label !== null);
                });
            if (this.secondaryLadderTreeNodes.length === 1) {
                this.secondaryLadderTreeNodes[0].data.breakDown = this.selectedLadderConfig.name;
            }
            this.isInError = false;
        }
    }

    onShowSecondaryLadder(event) {
        setTimeout(() => {
            if (this.showSecondaryLadder) {
                if (this.selectedBreakDownConfig && this.selectedCurrency) {
                    const request = this.buildMetricDataRequest(this.selectedLadderConfig, this.selectedComparisonOperatingDate);
                    const ladderRootNode = {} as TreeNode;
                    this.buildTreeNodesFromRequest(request, ladderRootNode, 1)
                        .then(() => {
                            this.rebuildSecondaryLadder(ladderRootNode);
                        })
                        .catch((err) => {
                            console.log(err);
                            this.isInError = true;
                            this.clearData();
                        });
                }
            }
        }, 100);
    }

    onComparisonOperatingDate() {
        this.onShowSecondaryLadder(null);
    }

    async showReportQuery(): Promise<void> {
        const reportQueryRequest: GetALMReportQueryRequest = { batchIdentifier: this.selectedBatchIdentifier } as GetALMReportQueryRequest;
        const reportQueryResult: GetALMReportQueryResult = await this.awsUtil
            .webAPICall<GetALMReportQueryResult>(WebApiEndpoints.QueryALMReportQuery, reportQueryRequest);
        // Handle Top data
        const topByConfig: { [key: string]: TopNTableData[] } = reportQueryResult.topData
            .sort((d1: ALMReportQueryData, d2: ALMReportQueryData) => {
                return Math.abs(d2.notional) - Math.abs(d1.notional);
            })
            .reduce((grouped, data) => {
                const key = data.config;
                grouped[key] = grouped[key] || [];
                grouped[key].push({
                    label: data.top,
                    values: [data.notional]
                } as TopNTableData);
                this.reportQueryConfigToType[data.config] = 'TOP';
                return grouped;
            }, {});
        // Query the Historical data per config
        // const historicalData: GetALMBreakDownQueryDataResult[] = await Promise.all();
        const topHistoricalDataByConfig = await Promise.all(Object.keys(topByConfig)
            .map(async (topConfig: string) => {
                const historicalRequest = {
                    type: 'METRIC_TREND',
                    scenarioType: 'BASE',
                    batchIdentifier: this.selectedBatchIdentifier,
                    breakDownQueryConfigName: topConfig,
                    breakDown: 'TOP',
                } as GetALMBreakDownQueryDataRequest;
                const result = await this.awsUtil
                    .webAPICall<GetALMBreakDownQueryDataResult>(WebApiEndpoints.QueryALMMetricData, historicalRequest);
                const topBreakDownDatas: ALMBreakDownData[] = result.breakDownData;

                const breakDownDataByDate: { [key: string]: ALMBreakDownData[] } = topBreakDownDatas
                    .reduce((grouped, data) => {
                        const key = data.opDt;
                        grouped[key] = grouped[key] || [];
                        grouped[key].push(data);
                        grouped[key] = grouped[key]
                            .sort((bdd1: ALMBreakDownData, bdd2: ALMBreakDownData) => {
                                return (Math.abs(bdd1.bdn) > Math.abs(bdd2.bdn)) ? -1 : 1;
                            });
                        return grouped;
                    }, {});
                const topBreakDownDatasByTop = topBreakDownDatas
                    .sort((d1: ALMBreakDownData, d2: ALMBreakDownData) => {
                        return d1.opDt < d2.opDt ? -1 : 1;
                    }).reduce((grouped, data) => {
                        const key = data.bd1;
                        grouped[key] = grouped[key] || [];
                        const rankIndex = breakDownDataByDate[data.opDt]
                            .findIndex((bdd: ALMBreakDownData) => {
                                return bdd.bd1 === key;
                            });
                        grouped[key].push({
                            date: data.opDt,
                            value: data.bdn,
                            rank: rankIndex + 1
                        } as TopNHistoricalData);
                        return grouped;
                    }, {});

                return topBreakDownDatasByTop;

            }));

        // );

        // Organize the Top Data
        this.reportQueryTopNTableConfigs = Object.keys(topByConfig)
            .map((config: string, configIndex: number) => {
                const data: TopNTableData[] = topByConfig[config];
                const historicalData = topHistoricalDataByConfig[configIndex];
                return {
                    subject: config,
                    columnNames: [''],
                    data: data,
                    historicalDataByTop: historicalData,
                } as TopNTableConfig;
            });

        // Handle Count, Notional, and CountAndNotional
        reportQueryResult.countData
            .forEach((data: ALMReportQueryData) => {
                this.reportQueryConfigToType[data.config] = 'COUNT';
            });
        reportQueryResult.notionalData
            .forEach((data: ALMReportQueryData) => {
                this.reportQueryConfigToType[data.config] = 'NOTIONAL';
            });
        reportQueryResult.countAndNotionalData
            .forEach((data: ALMReportQueryData) => {
                this.reportQueryConfigToType[data.config] = 'COUNT_AND_NOTIONAL';
            });
        const countNotionalData: ALMReportQueryData[] = []
            .concat(reportQueryResult.countData)
            .concat(reportQueryResult.notionalData)
            .concat(reportQueryResult.countAndNotionalData);
        const transformedData = countNotionalData
            .sort((d1: ALMReportQueryData, d2: ALMReportQueryData) => {
                return Math.abs(d2.notional) - Math.abs(d1.notional);
            })
            .map((data: ALMReportQueryData) => {
                const bdd = {
                    bd1: data.breakDown1,
                    bd2: data.breakDown2,
                    bd3: data.breakDown3,
                    bd4: data.breakDown4,
                    lv1: data.count || 0,
                    lv2: data.notional,
                } as ALMBreakDownData;
                bdd['config'] = data.config;
                return bdd;
            });
        const rootNode = {} as TreeNode;
        walkAndBuildTreeNode(['COUNT', 'SUM'], rootNode, transformedData,
            ['lv1', 'lv2'], ['lv1', 'lv2'],
            ['config', 'bd1', 'bd2', 'bd3', 'bd4'], -1, this.selectedCurrency, this.almBucketing);
        rootNode.children
            .forEach((node: TreeNode) => {
                node.expanded = false;
            });
        this.reportQueryTreeNodes = rootNode.children;
    }

    statisticsBreakDownNodeSelected(event) {
        const selectedBreakDownValues = [];
        let parentNode = event.node
        while (parentNode && parentNode.parent) {
            selectedBreakDownValues.unshift(parentNode.data.breakDown);
            parentNode = parentNode.parent;
        }
        if (this.historicalChartComponents) {
            this.historicalChartComponents
                .forEach((historicalChartComponent: ALMHistoricalChartComponent) => {
                    historicalChartComponent.setToLoading();
                })
        }
        const request = {
            type: 'METRIC_TREND',
            scenarioType: 'BASE',
            batchIdentifier: this.selectedBatchIdentifier,
            breakDownQueryConfigName: parentNode.data.breakDown,
            breakDown: this.reportQueryConfigToType[parentNode.data.breakDown],
            breakDownValues: selectedBreakDownValues,
        } as GetALMBreakDownQueryDataRequest;
        createALMHistoricalData(
            this.awsUtil,
            request,
            'SUM',
            this.selectedCurrency,
            this.almBucketing
        )
            .then((historicalData: ALMHistoricalData[]) => {
                this.notionalHistoricalData = historicalData;
                const countHistoricalData: ALMHistoricalData[] = JSON.parse(JSON.stringify(historicalData));
                this.countHistoricalData = countHistoricalData
                    .map((countData: ALMHistoricalData) => {
                        countData.amount = countData.count;
                        countData.rolling15DayDiff = countData.rolling15DayCountDiff;
                        countData.rolling30DayDiff = countData.rolling30DayCountDiff;
                        return countData;
                    });
            });
    }

    applyGlobalFilter(event) {
        this.globalFilterValue = event.target.value;
        if (this.breakDownLadderTable1) {
            this.breakDownLadderTable1.filterGlobal(event.target.value, 'contains');
        }
        if (this.breakDownLadderTable2) {
            this.breakDownLadderTable2.filterGlobal(event.target.value, 'contains');
        }
    }

    ladder1BreakDownNodeSelected(event) {
    }

    ladder2BreakDownNodeSelected(event) {
    }


    syncNodeExpansion(nodes1: TreeNode[], nodes2: TreeNode[]) {
        if (nodes1 && nodes2) {
            nodes1
                .forEach((n1) => {
                    const found2 = nodes2.find((on) => {
                        return on.label === n1.label;
                    });
                    if (found2) {
                        found2.expanded = n1.expanded;
                        this.syncNodeExpansion(n1.children, found2.children);
                    }
                });
        }
    }

    ladder1BreakDownNodeExpansionChanged(event) {
        if (this.breakDownLadderTable1 && this.breakDownLadderTable2) {
            const nodes1 = this.breakDownLadderTable1.ladderTreeNodes;
            const nodes2 = this.breakDownLadderTable2.ladderTreeNodes;
            if (!this.globalFilterValue) {
                this.syncNodeExpansion(nodes1, nodes2);
                this.breakDownLadderTable2.filterGlobal(this.globalFilterValue, 'contains');
            }
        }
    }

    ladder2BreakDownNodeExpansionChanged(event) {
        // Don't reverse sync as it gets complex with the interaction of the filtering and retaining expansion, etc.
        // if (this.breakDownLadderTable1 && this.breakDownLadderTable2) {
        //     const nodes1 = this.breakDownLadderTable1.ladderTreeNodes;
        //     const nodes2 = this.breakDownLadderTable2.ladderTreeNodes;
        //     this.syncNodeExpansion(nodes2, nodes1);
        //     this.breakDownLadderTable1.filterGlobal(this.globalFilterValue, 'contains');
        // }
    }

    breakDownOrderDrop(event: CdkDragDrop<SelectItem[]>) {
        moveItemInArray(this.breakDownLevels, event.previousIndex, event.currentIndex);
        this.rebuildLaddersFromExistingData();
    }

}
